import { carouselConfig, component, mergeConfig } from '@salutejs/plasma-new-hope/css';

const mergedConfig = mergeConfig(carouselConfig);
const CarouselComponent = component(mergedConfig);

export const CarouselOld = CarouselComponent;
